import './udostepnijCtrl';



// WEBPACK FOOTER //
// src/js/controllers/udostepnij/index.js